var map = {
	"./agentAvatar/BR_agent.png": 73617,
	"./agentAvatar/ID_agent.png": 60713,
	"./agentAvatar/MX_agent.png": 64565,
	"./agentAvatar/MY_agent.png": 18944,
	"./agentAvatar/PH_agent.png": 81851,
	"./agentAvatar/SG_agent.png": 85303,
	"./agentAvatar/TH&VN_agent.png": 25053,
	"./agentAvatar/TW_agent.png": 88445,
	"./agentAvatar/ar.png": 2152,
	"./agentAvatar/bank_id.png": 23233,
	"./agentAvatar/br.png": 52382,
	"./agentAvatar/cl.png": 22005,
	"./agentAvatar/co.png": 21042,
	"./agentAvatar/default.png": 36953,
	"./agentAvatar/es.png": 60585,
	"./agentAvatar/fr.png": 17456,
	"./agentAvatar/id.png": 41137,
	"./agentAvatar/in.png": 79329,
	"./agentAvatar/mx.png": 35318,
	"./agentAvatar/my.png": 47844,
	"./agentAvatar/ph.png": 59095,
	"./agentAvatar/pl.png": 50359,
	"./agentAvatar/sg.png": 60506,
	"./agentAvatar/th.png": 8645,
	"./agentAvatar/tw.png": 53457,
	"./agentAvatar/vn.png": 98638,
	"./announcement_alert.svg": 83926,
	"./arrow-right@2x.png": 84028,
	"./arrow-up.svg": 96977,
	"./arrow_down@2x.png": 60438,
	"./arrow_down_bank.svg": 13802,
	"./arrow_down_grey.svg": 11067,
	"./arrow_down_orange.svg": 35061,
	"./arrow_down_write.svg": 56121,
	"./arrow_left.svg": 87082,
	"./arrow_right.svg": 4745,
	"./arrow_right_bottom.svg": 31341,
	"./arrow_right_up.svg": 89546,
	"./avatar@2x.png": 32371,
	"./back.svg": 47616,
	"./back_arrow.svg": 57540,
	"./back_arrow_bank.svg": 38693,
	"./bank_announcement_alert.svg": 43760,
	"./bank_bubble_right@4x.png": 28177,
	"./bank_ic_general_send_primary@2x.png": 15866,
	"./botAvatar/ar.png": 38997,
	"./botAvatar/bank_default_avatar.png": 42621,
	"./botAvatar/bank_id.png": 14598,
	"./botAvatar/bank_sg_default_avatar.jpg": 75726,
	"./botAvatar/br.png": 417,
	"./botAvatar/cl.png": 20979,
	"./botAvatar/co.png": 28007,
	"./botAvatar/default.png": 47733,
	"./botAvatar/es.png": 8911,
	"./botAvatar/fr.png": 81933,
	"./botAvatar/id.png": 43392,
	"./botAvatar/in.png": 4727,
	"./botAvatar/mx.png": 88192,
	"./botAvatar/my.png": 45302,
	"./botAvatar/ph.png": 19966,
	"./botAvatar/pl.png": 24908,
	"./botAvatar/sg.png": 11080,
	"./botAvatar/th.png": 11016,
	"./botAvatar/tw.png": 84368,
	"./botAvatar/vn.png": 25036,
	"./bubble_left@4x.png": 69421,
	"./bubble_right@4x.png": 42077,
	"./camera.svg": 33823,
	"./cb_ic_topup.png": 69228,
	"./cb_ic_topup@2x.png": 37659,
	"./cb_ic_withdraw.png": 45591,
	"./cb_ic_withdraw@2x.png": 56013,
	"./chat.svg": 35384,
	"./chatbot_avatar@2x.png": 82603,
	"./clear-icon.svg": 23042,
	"./close@2x.png": 69623,
	"./default_img.svg": 18166,
	"./drawer_close.svg": 27233,
	"./drawer_close@2x.png": 9421,
	"./end_chat.svg": 16358,
	"./expand.svg": 86764,
	"./fail_to_load.svg": 41490,
	"./feedback_no.svg": 50192,
	"./feedback_yes.svg": 89789,
	"./file.svg": 27528,
	"./fileType/file_csv.svg": 18651,
	"./fileType/file_default.svg": 38678,
	"./fileType/file_doc.svg": 53243,
	"./fileType/file_docx.svg": 87912,
	"./fileType/file_pdf.svg": 30757,
	"./fileType/file_xls.svg": 64286,
	"./fileType/file_xlsm.svg": 67458,
	"./fileType/file_xlsx.svg": 32901,
	"./finger.svg": 45946,
	"./general_info_primary.svg": 59017,
	"./general_send_primary.svg": 63190,
	"./general_send_primary_white.svg": 20847,
	"./general_warning_icon.svg": 23094,
	"./hot_question_down.svg": 91915,
	"./hot_question_mask.svg": 60381,
	"./hot_question_right_arrow.svg": 5794,
	"./ic-close.svg": 98668,
	"./ic-down-orange.svg": 48298,
	"./ic-down.svg": 29428,
	"./ic-up.svg": 11908,
	"./ic_cbot_topup@2x.png": 57221,
	"./ic_cbot_withdrawID@2x.png": 17171,
	"./ic_general_general_info_primary@2x.png": 10387,
	"./ic_general_send_primary@2x.png": 10630,
	"./ic_general_send_white@3x.png": 59485,
	"./ic_guarantee@2x.png": 32977,
	"./ic_refresh.svg": 71497,
	"./icon_transaction_bank.png": 88598,
	"./icon_transaction_bank@2x.png": 56712,
	"./icon_transaction_card@2x.png": 8251,
	"./image_failure.svg": 65343,
	"./image_success.svg": 61742,
	"./input-shape.svg": 92310,
	"./intent/account_fraud.svg": 71763,
	"./intent/bd.svg": 97529,
	"./intent/content_legal.svg": 79245,
	"./intent/digital_product.svg": 8253,
	"./intent/food_delivery.svg": 93196,
	"./intent/general.svg": 85447,
	"./intent/img_shopee_express.png": 87428,
	"./intent/logistics.svg": 16593,
	"./intent/marketing.svg": 15598,
	"./intent/others.svg": 9921,
	"./intent/return_refund.svg": 56551,
	"./intent/shopee_payment.svg": 32951,
	"./intent/shopeepay.svg": 32463,
	"./intent/spaylater.svg": 71588,
	"./live-agent-sc-icon.svg": 19156,
	"./loading_circle.png": 61493,
	"./loading_circle.svg": 62906,
	"./more_input.svg": 54593,
	"./msg_failure.png": 28815,
	"./new-category/account_fraud.svg": 54660,
	"./new-category/air_pay.svg": 97228,
	"./new-category/airpay.svg": 49772,
	"./new-category/bd.svg": 73527,
	"./new-category/content_legal.svg": 30986,
	"./new-category/digital_product.svg": 95512,
	"./new-category/food_delivery.svg": 3163,
	"./new-category/general.svg": 11627,
	"./new-category/img_shopee_express.png": 4898,
	"./new-category/img_shopee_express_tw.png": 4551,
	"./new-category/logistics.svg": 55732,
	"./new-category/marketing.svg": 7489,
	"./new-category/mitra.svg": 98573,
	"./new-category/others.svg": 41931,
	"./new-category/return_refund.svg": 5257,
	"./new-category/shopee_payment.svg": 53957,
	"./new-category/spaylater.svg": 55688,
	"./no_order@2x.png": 98840,
	"./order_none@2x.png": 51501,
	"./order_others@2x.png": 61101,
	"./orders.svg": 42200,
	"./other-frequently-asked.svg": 11382,
	"./photo.svg": 94236,
	"./play_video.svg": 25397,
	"./reload.svg": 91879,
	"./return.svg": 34088,
	"./sea_bank_back_arrow.svg": 2526,
	"./shape.png": 72895,
	"./shape.svg": 35240,
	"./shop_icon@2x.png": 56414,
	"./something_wrong@2x.png": 26014,
	"./support_case.svg": 38016,
	"./system.svg": 2589,
	"./ui-optimisation-recommender/ui-optimisation-hot-question-icon.svg": 10504,
	"./ui-optimisation-recommender/ui-optimisation-milestone-1.svg": 74505,
	"./ui-optimisation-recommender/ui-optimisation-milestone-2.svg": 71323,
	"./ui-optimisation-recommender/ui-optimisation-milestone-3.svg": 90824,
	"./ui-optimisation-recommender/ui-optimisation-milestone-4.svg": 70883,
	"./ui-optimisation-recommender/ui-optimisation-order-default-img.svg": 77234,
	"./ui-optimisation-recommender/ui-optimisation-recommender-right-arrow.svg": 47664,
	"./update-available.png": 92134,
	"./video_failed.svg": 80169,
	"./video_loading.svg": 88492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23028;